import { render, staticRenderFns } from "./dragon-activity-statistics.vue?vue&type=template&id=c4506210&scoped=true&"
import script from "./dragon-activity-statistics.vue?vue&type=script&lang=js&"
export * from "./dragon-activity-statistics.vue?vue&type=script&lang=js&"
import style0 from "./dragon-activity-statistics.vue?vue&type=style&index=0&id=c4506210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4506210",
  null
  
)

export default component.exports